import { render, staticRenderFns } from "./FiltrePlugin.vue?vue&type=template&id=16dfedec&scoped=true"
import script from "./FiltrePlugin.vue?vue&type=script&lang=ts"
export * from "./FiltrePlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./FiltrePlugin.vue?vue&type=style&index=0&id=16dfedec&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "16dfedec",
  null
  ,true
)

export default component.exports